import {combineReducers} from 'redux';

import userData from './userData';
import ui from './ui';

export const LivingLedgerReducers = combineReducers({
    userData,
    ui,
});